<template>
  <v-menu :activator="activateMenu" :close-on-content-click="false">
    <!-- Meeting dropdown -->
    <template v-if="isMeeting">
      <div class="mm-card">
        <!-- background decoration -->
        <div class="mm-card__bg-glow"></div>
        <div class="mm-card__grid"></div>

        <!-- header -->
        <div class="mm-card__header">
          <div class="mm-card__header-left">
            <div class="mm-card__pulse-ring"></div>
            <div class="mm-card__header-icon">
              <v-icon size="13" color="#fff">mdi-video-outline</v-icon>
            </div>
          </div>
          <div class="mm-card__header-text">
            <span class="mm-card__header-title">Start Meeting</span>
            <span class="mm-card__header-sub">{{ options.length }} types available</span>
          </div>
          <div class="mm-card__header-live">
            <span class="mm-live-dot"></span>
            <span class="mm-live-label">LIVE</span>
          </div>
        </div>

        <!-- divider -->
        <div class="mm-card__divider">
          <span class="mm-card__divider-line"></span>
          <span class="mm-card__divider-text">choose type</span>
          <span class="mm-card__divider-line"></span>
        </div>

        <!-- list -->
        <div class="mm-card__list">
          <button v-for="(item, index) in options" :key="index" class="mm-item"
            :class="`mm-item--${getMeetingColor(item)}`" :style="{ animationDelay: `${index * 0.05}s` }"
            @click="action(index, item)">
            <span class="mm-item__icon-wrap">
              <v-icon size="15" color="#fff">{{ getMeetingIcon(item) }}</v-icon>
            </span>
            <div class="mm-item__body">
              <span class="mm-item__name">{{ item.title || item.name }}</span>
              <span class="mm-item__desc">{{ getMeetingDesc(item) }}</span>
            </div>
            <span class="mm-item__badge">{{ (item.code || 'GO').toUpperCase() }}</span>
            <v-icon size="13" class="mm-item__arrow">mdi-arrow-right</v-icon>
          </button>
        </div>

        <!-- footer -->
        <div class="mm-card__footer">
          <v-icon size="10" color="rgba(148,210,255,0.4)">
            mdi-account-group-outline
          </v-icon>
          <span class="mm-card__footer-text">Manage meetings with ease</span>
        </div>
      </div>
    </template>

    <!-- Search dropdown -->
    <template v-else-if="isSearch">
      <div class="sr-card">
        <div class="sr-card__label">Search by</div>
        <button v-for="(item, index) in options" :key="index" class="sr-item" @click="action(index, item)">
          <v-icon size="14" :color="index === 0 ? '#6366f1' : '#7c3aed'">
            {{ index === 0 ? 'mdi-pound' : 'mdi-text-search' }}
          </v-icon>
          <div class="sr-item__body">
            <span class="sr-item__name">{{ item.title }}</span>
            <span class="sr-item__desc">{{ index === 0 ? 'Reference number' : 'Issue subject' }}</span>
          </div>
          <v-icon size="11" color="#cbd5e1">mdi-chevron-right</v-icon>
        </button>
      </div>
    </template>

    <!-- Default list -->
    <template v-else>
      <v-list max-height="350px" style="width: 100% !important" :style="type == 'sort' ? 'min-width: 170px;' : ''">
        <v-list-item v-for="(item, index) in options" :key="index" :value="index" @click="action(index, item)">
          <template v-if="showAvatar" v-slot:prepend>
            <CustomAvatar2 class="ma-0 mb-2" :size="'medium'"
              :fName="item.first_name ? item.first_name : item.first_Name" :lName="item.last_name"
              :imgUrl="item.image_profile_id ? item.image_profile_id : null" :theme="item.theme">
            </CustomAvatar2>
          </template>
          <v-list-item-title class="ml-3 mt-1" style="display: flex;gap: 10px;">
            <v-checkbox v-if="type == 'sort'" @click="changeSort(item)"></v-checkbox>
            <div style="display: flex;align-items: center;">
              {{ item.title ? item.title : item.display_value ? item.display_value : item.name }}
            </div>
            <v-list-item-subtitle v-if="item.subtitle && type != 'follower'">
              {{ item.subtitle }}
            </v-list-item-subtitle>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </v-menu>
</template>
<script>
import moment from "moment-timezone";
import UserService from "@/api/service/UserService";
import CustomAvatar2 from "@/components/ui/CustomAvatar2.vue";
export default {
  props: ["activator", "type", "options", "showAvatar",],
  components: {
    CustomAvatar2,
  },
  computed: {
    isMeeting() {
      return this.activator === '#meeting-menu-activator';
    },
    isSearch() {
      return this.activator === '#search-activator';
    },
  },
  data() {
    return {
      activeIndex: 0,
      sortValue: [],
      activateMenu: null,
      selected: false,
      userDetails: JSON.parse(localStorage.getItem("user_details"))
    };
  },
  watch: {
    activator() {
      this.activateMenu = this.activator;
    },
  },
  created() {
    this.activateMenu = this.activator;
  },
  methods: {
    getMeetingIcon(item) {
      const code = (item.code || '').toUpperCase();
      const map = {
        'ME': 'mdi-account-group-outline',
        'CA': 'mdi-phone-outline',
        'TR': 'mdi-school-outline',
        'MBS': 'mdi-briefcase-outline',
        'HUD': 'mdi-account-voice',
      };
      return map[code] || 'mdi-calendar-clock-outline';
    },
    getMeetingColor(item) {
      const code = (item.code || '').toUpperCase();
      const map = { 'ME': 'blue', 'CA': 'green', 'TR': 'amber', 'MBS': 'purple', 'HUD': 'rose' };
      return map[code] || 'cyan';
    },
    getMeetingDesc(item) {
      const code = (item.code || '').toUpperCase();
      const map = {
        'ME': 'Team discussion', 'CA': 'Phone / video call',
        'TR': 'Training session', 'MBS': 'Business meeting', 'HUD': 'Quick huddle',
      };
      return map[code] || 'Meeting session';
    },
    moment,
    changeSort(data) {
      const indexToRemove = this.sortValue.findIndex(
        (item) => item.value === data.value
      );
      if (indexToRemove > -1) {
        this.sortValue.splice(indexToRemove, 1);
      } else {
        this.sortValue.push(data);
      }
      this.$emit('sortData', this.sortValue)
    },
    async setLogoutAction() {
      try {
        let $session = await UserService.findSessions({ "sessionId": localStorage.getItem("sessionId") });
        if ($session) {
          //alert(moment())
          //alert(moment($session[0].proposed_end_date).to
          let $d1 = moment(new Date()).tz('UTC')
          let $d2 = moment(new Date($session[0].proposed_end_date)).tz('UTC')



          let $balance = $d1.diff($d2, 'seconds')
          // alert($balance)
          //moment().diff(moment(new Date($session[0].proposed_end_date).toLocaleString()),'hours')
          if ($balance < 60) {
            this.$store.commit('SET_SHIFT_IN_DUE', false)
          } else {
            this.$store.commit('SET_SHIFT_IN_DUE', true)
          }
          this.$store.commit('SET_LOGOUT_ACTION', true)
        }
      }
      catch (e) {
        this.$store.commit('SET_SHIFT_IN_DUE', false)
        this.$store.commit('SET_LOGOUT_ACTION', true)

      }
    },
    async action(index, item) {

      if (item.action) {

        if (item.title && item.title.toLowerCase() == 'logout') {
          await this.setLogoutAction()
          /*  let $sessions = await UserService.findSessions({user_id:this.userDetails.id,end_date:'null'});
            let $val = {};
            if($sessions && $sessions.length>0){
              $val = $sessions[0];
            }else{
              $val= JSON.parse(localStorage.getItem("USER_SESSIONS"));
            }
           
            let $expires = moment().diff(moment($val.proposed_end_date), 'seconds') > 0;
          
            if($expires){
              this.$store.commit("SET_OT_DIALOGUE", true);
              this.$store.commit("SET_NORMAL", false);
            }else{
              this.$store.commit("SET_NORMAL", true);
              this.$store.commit("SET_OT_DIALOGUE", false);
            } */
        } else {
          // this.$router.push(item.action)
          this.$router.push({
            path: item.action,
            query: item.query,
          });
        }
      } else {
        this.activeIndex = index;
      }
      if (this.type != 'sort') {
        this.$emit("menu-selected", item);
      }
      /*if (index == 1 && item.title == "Logout") {
            localStorage.removeItem("TOKEN");
            localStorage.removeItem("user_details");
            window.location = "http://" + this.host + "/login";
        } else if (index == 0 && item.title == "User Profile") {
            this.$router.push("/userprofile");
        }*/
    },
    getAvatarName(value) {
      let name =
        value && value.first_name
          ? value.first_name.charAt(0)
          : "" + value && value.last_name
            ? value.last_name.charAt(0)
            : "";
      return name;
    },
  },
};
</script>
<style scoped>
>>>.v-input__details {
  align-items: flex-end;
  display: flex;
  font-size: 0.75rem;
  font-weight: 400;
  grid-area: messages;
  letter-spacing: 0.0333333333em;
  line-height: normal;
  min-height: 22px;
  padding-top: 6px;
  overflow: hidden;
  justify-content: space-between;
  display: contents;
}

>>>.v-checkbox .v-selection-control {
  min-height: 0;
}

>>>.v-selection-control__input input {
  cursor: pointer;
  width: 100%;
  opacity: 0;
}

>>>.v-input {
  display: grid;
  flex: none;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  --v-input-chips-margin-top: 2px;
  width: 35px;
}

>>>.v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line {
  padding-inline-start: 5px;
  padding-inline-end: 5px;
}

.image {
  width: 35px;
  height: 35px;
}

>>>::-webkit-scrollbar {
  width: 6px;
  /* height: 6px; */
}

/* Track */
>>>::-webkit-scrollbar-track {
  background: #e8f3f9;
}

/* Handle */
>>>::-webkit-scrollbar-thumb {
  background: rgb(0, 0, 0, 0.12);
}

/* ══════════════════════════════════════
   MEETING CARD — Redesign
══════════════════════════════════════ */
.mm-card {
  position: relative;
  width: 280px;
  background: rgba(8, 18, 44, 0.92);
  border: 1px solid rgba(99, 179, 255, 0.2);
  border-radius: 18px;
  box-shadow:
    0 24px 64px rgba(0, 8, 30, 0.75),
    0 0 0 1px rgba(255, 255, 255, 0.05) inset,
    0 1px 0 rgba(99, 179, 255, 0.15) inset;
  backdrop-filter: blur(24px);
  overflow: hidden;
  padding: 14px 10px 10px;
}

/* background glow blob */
.mm-card__bg-glow {
  position: absolute;
  top: -40px;
  right: -30px;
  width: 160px;
  height: 160px;
  background: radial-gradient(circle, rgba(56, 189, 248, 0.12) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
}

/* subtle dot grid */
.mm-card__grid {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(99, 179, 255, 0.07) 1px, transparent 1px);
  background-size: 18px 18px;
  pointer-events: none;
  z-index: 0;
}

/* header */
.mm-card__header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 4px 12px;
  border-bottom: 1px solid rgba(99, 179, 255, 0.1);
  margin-bottom: 8px;
}

.mm-card__header-left {
  position: relative;
  flex-shrink: 0;
}

.mm-card__pulse-ring {
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  border: 1.5px solid rgba(56, 189, 248, 0.4);
  animation: mm-pulse-ring 2s ease-out infinite;
}

@keyframes mm-pulse-ring {
  0% {
    transform: scale(0.85);
    opacity: 0.8;
  }

  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}

.mm-card__header-icon {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  background: linear-gradient(135deg, #0ea5e9, #6366f1);
  box-shadow: 0 4px 14px rgba(14, 165, 233, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mm-card__header-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.mm-card__header-title {
  font-size: 0.8rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: 0.3px;
}

.mm-card__header-sub {
  font-size: 0.62rem;
  color: rgba(148, 210, 255, 0.55);
  font-weight: 400;
}

.mm-card__header-live {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(34, 197, 94, 0.12);
  border: 1px solid rgba(34, 197, 94, 0.25);
  border-radius: 20px;
  padding: 3px 8px;
}

.mm-live-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 5px rgba(34, 197, 94, 0.8);
  animation: mm-live-blink 1.4s ease-in-out infinite;
}

@keyframes mm-live-blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }
}

.mm-live-label {
  font-size: 0.55rem;
  font-weight: 800;
  color: #4ade80;
  letter-spacing: 1px;
}

/* divider */
.mm-card__divider {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 4px 8px;
}

.mm-card__divider-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(99, 179, 255, 0.2), transparent);
}

.mm-card__divider-text {
  font-size: 0.58rem;
  font-weight: 600;
  color: rgba(148, 210, 255, 0.35);
  letter-spacing: 0.8px;
  text-transform: uppercase;
  white-space: nowrap;
}

/* list */
.mm-card__list {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 2px;
  scrollbar-width: thin;
  scrollbar-color: rgba(56, 189, 248, 0.25) transparent;
}

.mm-card__list::-webkit-scrollbar {
  width: 3px;
}

.mm-card__list::-webkit-scrollbar-track {
  background: transparent;
}

.mm-card__list::-webkit-scrollbar-thumb {
  background: rgba(56, 189, 248, 0.25);
  border-radius: 4px;
}

/* meeting row */
.mm-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 10px;
  border: 1px solid transparent;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 11px;
  cursor: pointer;
  text-align: left;
  animation: mm-item-in 0.3s ease both;
  transition: background 0.15s, border-color 0.15s, transform 0.12s;
}

@keyframes mm-item-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* color variants — icon bg + hover border */
.mm-item--blue .mm-item__icon-wrap {
  background: linear-gradient(135deg, #0ea5e9, #38bdf8);
  box-shadow: 0 3px 10px rgba(14, 165, 233, 0.45);
}

.mm-item--green .mm-item__icon-wrap {
  background: linear-gradient(135deg, #10b981, #34d399);
  box-shadow: 0 3px 10px rgba(16, 185, 129, 0.45);
}

.mm-item--amber .mm-item__icon-wrap {
  background: linear-gradient(135deg, #f59e0b, #fbbf24);
  box-shadow: 0 3px 10px rgba(245, 158, 11, 0.45);
}

.mm-item--purple .mm-item__icon-wrap {
  background: linear-gradient(135deg, #8b5cf6, #a78bfa);
  box-shadow: 0 3px 10px rgba(139, 92, 246, 0.45);
}

.mm-item--rose .mm-item__icon-wrap {
  background: linear-gradient(135deg, #f43f5e, #fb7185);
  box-shadow: 0 3px 10px rgba(244, 63, 94, 0.45);
}

.mm-item--cyan .mm-item__icon-wrap {
  background: linear-gradient(135deg, #06b6d4, #22d3ee);
  box-shadow: 0 3px 10px rgba(6, 182, 212, 0.45);
}

.mm-item--blue:hover {
  background: rgba(14, 165, 233, 0.1);
  border-color: rgba(14, 165, 233, 0.25);
}

.mm-item--green:hover {
  background: rgba(16, 185, 129, 0.1);
  border-color: rgba(16, 185, 129, 0.25);
}

.mm-item--amber:hover {
  background: rgba(245, 158, 11, 0.1);
  border-color: rgba(245, 158, 11, 0.25);
}

.mm-item--purple:hover {
  background: rgba(139, 92, 246, 0.1);
  border-color: rgba(139, 92, 246, 0.25);
}

.mm-item--rose:hover {
  background: rgba(244, 63, 94, 0.1);
  border-color: rgba(244, 63, 94, 0.25);
}

.mm-item--cyan:hover {
  background: rgba(6, 182, 212, 0.1);
  border-color: rgba(6, 182, 212, 0.25);
}

.mm-item:hover {
  transform: translateX(3px);
}

.mm-item__icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.15s;
}

.mm-item:hover .mm-item__icon-wrap {
  transform: scale(1.08);
}

.mm-item__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.mm-item__name {
  font-size: 0.8rem;
  font-weight: 700;
  color: rgba(225, 240, 255, 0.95);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mm-item__desc {
  font-size: 0.62rem;
  color: rgba(148, 210, 255, 0.45);
  font-weight: 400;
  white-space: nowrap;
}

.mm-item__badge {
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.6px;
  color: rgba(148, 210, 255, 0.5);
  background: rgba(99, 179, 255, 0.08);
  border: 1px solid rgba(99, 179, 255, 0.15);
  border-radius: 5px;
  padding: 2px 6px;
  flex-shrink: 0;
}

.mm-item__arrow {
  color: rgba(148, 210, 255, 0.25);
  flex-shrink: 0;
  transition: color 0.15s, transform 0.15s;
}

.mm-item:hover .mm-item__arrow {
  color: rgba(148, 210, 255, 0.8);
  transform: translateX(3px);
}

/* footer */
.mm-card__footer {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(99, 179, 255, 0.08);
}

.mm-card__footer-text {
  font-size: 0.6rem;
  color: rgba(148, 210, 255, 0.3);
  font-weight: 400;
  letter-spacing: 0.3px;
}

/* ══════════════════════════════════════
   SEARCH CARD — minimal
══════════════════════════════════════ */
.sr-card {
  width: 220px;
  background: #ffffff;
  border: 1px solid #e9edf5;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sr-card__label {
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 4px 8px 6px;
}

.sr-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  background: transparent;
  border-radius: 7px;
  cursor: pointer;
  text-align: left;
  transition: background 0.13s;
}

.sr-item:hover {
  background: #f5f7ff;
}

.sr-item__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.sr-item__name {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
}

.sr-item__desc {
  font-size: 10.5px;
  color: #94a3b8;
  font-weight: 400;
}
</style>